import { ref } from 'vue';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastMessage {
  id: number;
  message: string;
  type: ToastType;
}

const toasts = ref<ToastMessage[]>([]);
let nextId = 0;

function remove(id: number): void {
  toasts.value = toasts.value.filter((t) => t.id !== id);
}

function show(message: string, type: ToastType = 'info', duration = 4000): void {
  const id = nextId++;
  toasts.value.push({ id, message, type });
  setTimeout(() => remove(id), duration);
}

export function useToast() {
  return {
    toasts,
    show,
    remove,
    success: (message: string) => show(message, 'success'),
    error: (message: string) => show(message, 'error'),
    info: (message: string) => show(message, 'info'),
  };
}
